import { lazy, Suspense } from 'react';
import type { PdfDeckProps, PdfPagesProps } from './PdfDocument';
import PaperSkeleton from './PaperSkeleton';
import PdfDeckFrame, { PDF_DECK_GROUP } from './PdfDeckFrame';

const LazyPdfPages = lazy(() => import('./PdfDocument').then((module) => ({ default: module.PdfPages })));
const LazyPdfDeck = lazy(() => import('./PdfDocument').then((module) => ({ default: module.PdfDeck })));

export const PdfPages = (props: PdfPagesProps) => (
	<Suspense fallback={<PaperSkeleton />}>
		<LazyPdfPages {...props} />
	</Suspense>
);

export const PdfDeck = (props: PdfDeckProps) => (
	<Suspense fallback={<PdfDeckFrame />}>
		<LazyPdfDeck {...props} />
	</Suspense>
);

export type { PdfFile } from './PdfDocument';
export { PDF_MAX_ZOOM, usePinchZoom } from './usePinchZoom';
export { PaperSkeleton, PDF_DECK_GROUP, PdfDeckFrame };
